function waitForNostoJS() {
  return new Promise((resolve) => {
    const checkInterval = setInterval(() => {
      if (window.nostojs) {
        clearInterval(checkInterval);
        resolve(true);
      }
    }, 50);

    setTimeout(() => {
      clearInterval(checkInterval);
      resolve(false);
    }, 5000); // 5 seconds timeout
  });
}

waitForNostoJS().then((nostoLoaded) => {
  if (nostoLoaded) {

    nostojs(api => api.visit.setDoNotTrack(true));

    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      error => {
        if (error) {
          // Rescue error
        }

        if(window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
          nostojs(api => api.visit.setDoNotTrack(false));
        }
      },
     );

    if(Shopify.current_product.id) {
      trackPDPView(Shopify.current_product.id);
    }
  }
});

// Track PDP view

function trackPDPView(id) {
  window.nostojs(api => {
    api.defaultSession()
      .viewProduct(id)
      .load()
      .then(data => {
        console.log(data.recommendations);
      })
  });
}
